// =============================================================================
// Admin Analytics — a widget body's loading / error / content switch
// =============================================================================
import { PropsWithChildren } from "react";

import { CellErrorState } from "@pages/AdminAnalytics/components/CellErrorState";

interface CellBodyProps extends PropsWithChildren {
  loading: boolean;
  /** Shown while `loading`. */
  skeleton: React.ReactNode;
  error: boolean;
  onRetry?: () => void;
}

export const CellBody: React.FC<CellBodyProps> = ({ loading, skeleton, error, onRetry, children }) => {
  if (loading) return skeleton;
  if (error) return <CellErrorState onRetry={onRetry} />;
  return children;
};
